import React, { Fragment } from 'react';

function LoginItem(props) {

    let isJustForAdmin = (props.isJustForAdmin !== undefined) ? props.isJustForAdmin : false;
    let user = JSON.parse(localStorage.getItem('user'));
    console.log(user)
    let isValid = (isJustForAdmin) ? (user.role === "ROLE_ADMINISTRATOR") : true;
    return (
        <Fragment>
            {isValid ?
                <Fragment>

                        <input
                            type={props.type}
                            className={props.object.isValid ? "form-control" : "form-control is-invalid"}
                            name={props.name}
                            onChange={props.inputChangeHandler}
                            value={props.object.value}
                            placeholder={props.placeholder}

                        />
                        <small className="form-text text-danger">{props.object.message}</small>

                </Fragment>:<Fragment></Fragment>
            }
        </Fragment>

    )
}


export default LoginItem;


// WEBPACK FOOTER //
// ./src/components/LoginItem/LoginItem.jsx